interface Industry {
  icon: string;
  name: string;
  description: string;
  imageUrl: string;
}

const industries: Industry[] = [
  {
    icon: 'ri-shield-check-line',
    name: 'Insurance & Brokerages',
    description: 'Structured lead intake and policy-ready workflows that move prospects to coverage without manual effort.',
    imageUrl:
      'https://public.readdy.ai/ai/img_res/9efe7a3a42d5c7bd1a8f46466ca90e51.jpg',
  },
  {
    icon: 'ri-bank-line',
    name: 'Financial & Fintech',
    description: 'Precision-driven client engagement and qualification for high-intent financial service inquiries.',
    imageUrl:
      'https://readdy.ai/api/search-image?query=modern%20fintech%20financial%20office%20glass%20building%20interior%20data%20graphs%20screens%20professional%20minimal%20clean%20editorial%20photography%20dark%20accents&width=600&height=360&seq=henexa-ind-fin-v2&orientation=landscape',
  },
  {
    icon: 'ri-building-2-line',
    name: 'Real Estate',
    description: 'Consistent follow-up and pipeline visibility across every property inquiry and buyer touchpoint.',
    imageUrl:
      'https://readdy.ai/api/search-image?query=modern%20luxury%20real%20estate%20interior%20architecture%20minimal%20clean%20white%20bright%20open%20floor%20plan%20professional%20editorial%20photography%20property&width=600&height=360&seq=henexa-ind-re-v2&orientation=landscape',
  },
  {
    icon: 'ri-tools-line',
    name: 'Home Services & Trades',
    description: 'Immediate response and booked jobs without delay—so no service call goes unanswered.',
    imageUrl:
      'https://readdy.ai/api/search-image?query=professional%20home%20services%20technician%20team%20clean%20modern%20tool%20equipment%20organized%20work%20environment%20editorial%20photography%20bright%20clean%20minimal&width=600&height=360&seq=henexa-ind-hs-v2&orientation=landscape',
  },
  {
    icon: 'ri-briefcase-4-line',
    name: 'Professional Advisory',
    description: 'Organized client communication and intake systems for consultants, lawyers, and advisors.',
    imageUrl:
      'https://readdy.ai/api/search-image?query=professional%20advisory%20firm%20office%20meeting%20room%20minimal%20clean%20corporate%20interior%20editorial%20photography%20boardroom%20contemporary%20design&width=600&height=360&seq=henexa-ind-adv-v2&orientation=landscape',
  },
  {
    icon: 'ri-line-chart-line',
    name: 'Growth-Stage Teams',
    description: 'Scalable AI infrastructure that grows with your team and handles volume without adding headcount.',
    imageUrl:
      'https://readdy.ai/api/search-image?query=modern%20startup%20office%20open%20plan%20team%20collaboration%20bright%20minimal%20clean%20whiteboard%20screens%20contemporary%20design%20editorial%20photography%20technology%20company&width=600&height=360&seq=henexa-ind-gr-v2&orientation=landscape',
  },
];

export default function Industries() {
  return (
    <section id="industries" className="bg-[#F8FAFC] dark:bg-[#0C1322]">
      <div className="max-w-7xl mx-auto px-8 lg:px-16 py-28">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-20">
          <div>
            <span className="text-xs tracking-widest uppercase text-[#2563EB] font-medium block mb-5">
              Industries We Serve
            </span>
            <h2 className="text-5xl lg:text-6xl font-semibold text-[#0B2A4A] dark:text-white tracking-[-0.025em] leading-[1.0]">
              Built for industries<br />that move fast.
            </h2>
          </div>
          <p className="text-sm text-[#0B2A4A]/65 dark:text-white/55 max-w-xs tracking-wide leading-relaxed lg:text-right">
            Tailored to the pace, compliance needs, and client expectations of each sector.
          </p>
        </div>

        {/* Grid with image cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {industries.map((item) => (
            <div
              key={item.name}
              className="group rounded-2xl overflow-hidden border border-[#E5E7EB] dark:border-white/10 bg-white dark:bg-[#0F1928] hover:border-[#2563EB]/30 dark:hover:border-[#2563EB]/40 transition-all duration-300 cursor-default"
            >
              {/* Image */}
              <div className="relative h-44 overflow-hidden bg-[#E5E7EB] dark:bg-[#1A2338]">
                <img
                  src={item.imageUrl}
                  alt={item.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-white/30 dark:from-[#0F1928]/40 to-transparent" />
              </div>

              {/* Content */}
              <div className="p-7">
                <div className="w-9 h-9 flex items-center justify-center bg-[#F8FAFC] dark:bg-[#0C1322] rounded-lg border border-[#E5E7EB] dark:border-white/10 mb-5 group-hover:bg-[#2563EB]/8 group-hover:border-[#2563EB]/20 transition-colors">
                  <i className={`${item.icon} text-[#0B2A4A]/60 dark:text-white/50 group-hover:text-[#2563EB] text-base transition-colors`} />
                </div>
                <h3 className="text-base font-semibold text-[#0B2A4A] dark:text-white tracking-tight mb-2.5">
                  {item.name}
                </h3>
                <p className="text-sm text-[#0B2A4A]/70 dark:text-white/60 leading-relaxed tracking-wide">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
